import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/** Jump to the top of the page on every route change (multi-page behaviour). */
export default function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  }, [pathname]);
  return null;
}
